export interface Alert {
  id?: string,
  name: string,
  metric: string,
  campaign: string,
  timeframe: string,
  comparation: string,
  value: number,
  active?: boolean,
  notify: string,
  users?: any,
  comment?: string,
}

export abstract class AlertData {

  abstract createAlert(alert: Alert);
  abstract deleteAlert(id: string);
  abstract editAlert(alert: Alert, id:string);
  abstract getAlerts(pagination, filter, order);
  abstract getAlertId(id: string);
}
